import {createAction} from 'redux-actions'
import * as ActionTypes from './actionTypes'
import {createActionObject} from '../../redux/utils'
import {addTasks, handleCommonTaskUpdateErrors, savePageSettings,} from "../common/actions"
import rpcCall from "../../util/rpc/rpcCalls"
import messageResource from "../../messageResource"
import {getTask} from "../../entities/selectors"
import TaskManagementService from "../TaskManagementService"
import * as SyncCallbacks from "./syncCallbacks"
import {setTypesOfWorkList} from '../../entities/actions'
import {getVisibleTableTaskIds} from './selectors'
import {arrayToSet} from '../../atUtils'
import {changeAllTasksSelected as commonChangeAllTasksSelected} from '../taskSelection/actions'
import {taskFromRpc} from '../utils'

export const setColumnsOrder = createAction(ActionTypes.COLUMNS_ORDER_SET)

export const setColumnsShown = createAction(ActionTypes.COLUMNS_SHOWN_SET)

export const setLoadedTaskIds = createAction(ActionTypes.LOADED_TASK_IDS_SET)
export const addLoadedTaskIds = createAction(ActionTypes.LOADED_TASK_IDS_ADD)
const prependLoadedTaskIds = createAction(ActionTypes.LOADED_TASK_IDS_PREPEND)

export const addRecentlyCreatedTasks = (ids) => prependLoadedTaskIds(ids)

export const changeTasksSortingAction = (sorting) => (dispatch) => {
    dispatch(createActionObject(ActionTypes.TASKS_SORTING_CHANGE, sorting))
    dispatch(setLoaded(false))
    dispatch(savePageSettings())
}

export const changeAllTasksSelectedAction = () => (dispatch, getState) => {
    dispatch(commonChangeAllTasksSelected(arrayToSet(getVisibleTableTaskIds(getState()))))
}

export const setLoaded = createAction(ActionTypes.IS_LOADED_SET)

export const updateTaskTypeOfWork = (taskId, typeOfWorkId) => (dispatch, getState) => {
    const task = getTask(getState(), taskId)
    rpcCall("TaskManagementService.updateTaskTypeOfWork", [taskId, typeOfWorkId],
        (rpcError) => {
            if (rpcError.getTextStatus() === "rpc_customException") {
                const exception = rpcError.getErrorThrown().exception
                switch (exception) {
                    case "com.actimind.actitime.services.taskManagement.TypeOfWorkDeletedException":
                        alert(messageResource.getMessage("billing_type.js.error_type_was_deleted"))
                        dispatch(setTypesOfWorkList(rpcError.getErrorThrown().typesOfWork))
                        SyncCallbacks.afterTaskUpdated(taskId)
                        return true
                    case "com.actimind.actitime.services.taskManagement.TypeOfWorkArchivedException":
                        alert(messageResource.getMessage("billing_type.js.error_type_was_archived"))
                        dispatch(setTypesOfWorkList(rpcError.getErrorThrown().typesOfWork))
                        SyncCallbacks.afterTaskUpdated(taskId)
                        return true
                    case "com.actimind.actitime.services.FeatureIsDisabledException":
                        alert(messageResource.getMessage("task.error.billing_types_off"))
                        window.location.reload()
                        return true
                    default:
                        return handleCommonTaskUpdateErrors(task, exception, dispatch)
                }
            }
        })
        .then(data => {
            const task = taskFromRpc(data["task"])
            dispatch(addTasks([task]))
            SyncCallbacks.afterTaskUpdated(taskId)
        })
        .catch(() => {
            // error actions dispatched in error handler
        })
}



// WEBPACK FOOTER //
// ./web/js/taskManagement/tasksTable/actions.js